import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tj_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Fire a global event on 402 so any page can redirect user to /billing
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      window.dispatchEvent(new CustomEvent("tj:paywall", { detail: err.response.data?.detail || "Feature locked" }));
    }
    return Promise.reject(err);
  }
);

export function fileUrl(path) {
  const t = localStorage.getItem("tj_token") || "";
  return `${API}/files/${encodeURI(path)}?auth=${encodeURIComponent(t)}`;
}
